<template>
  <div
    v-if="showCookieBanner"
    class="d-flex align-items-center justify-content-center bg-jungle-mist py-3"
  >
    <div class="d-flex align-items-center flex-wrap">
      <div class="px-3">
        <p class="mb-0">
          The website use cookies to enable essential site functionality. By using our
          website you agree to our use of cookies
        </p>
        <a
          @click.prevent.stop="() => $emitter.emit('toggle-termly-modal', 'cookie-policy')"
          class="text-underline text-dark mr-3"
          href
          >Cookie Policy</a
        >
        <a
          @click.prevent.stop="() => $emitter.emit('toggle-termly-modal', 'eula')"
          class="text-underline text-dark mr-3"
          href
          >EULA</a
        >
        <a
          @click.prevent.stop="() => $emitter.emit('toggle-termly-modal', 'acceptable-use-policy')"
          class="text-underline text-dark"
          href
          >Acceptable Use Policy</a
        >
      </div>
      <div class="px-3 d-inline-flex align-items-center">
        <a
          @click.prevent.stop="() => handleCookieAcceptance(true)"
          class="btn btn-secondary btn-sm mt-3 px-4 mt-md-0 d-flex align-items-center justify-content-center"
          href
          >Got it!</a
        >
        <a
          @click.prevent.stop="() => handleCookieAcceptance(null)"
          class="btn btn-link btn-sm ml-2 text-uppercase d-flex align-items-center justify-content-center"
          href
          >Deny</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onBeforeMount, ref } from "@vue/composition-api";

export default defineComponent({
  name: "BannerPolicies",
  setup() {
    const showCookieBanner = ref(true);

    const handleCookieAcceptance = (accepted = true) => {
      try {
        localStorage.setItem("LQ_ShowCookieBanner", accepted);
        showCookieBanner.value = false;
      } catch (err) {
        console.error(err);
      }
    };

    onBeforeMount(() => {
      const value = JSON.parse(localStorage.getItem("LQ_ShowCookieBanner"));
      showCookieBanner.value = value === null ? true : value;
    });

    return {
      handleCookieAcceptance,
      showCookieBanner,
    };
  },
});
</script>
